export const EMAIL_AUDIT = {
  EMAIL_AUDIT_TITLE: { key: 'EMAIL_AUDIT_TITLE', value: 'Email Audit' },

  REQUEST_ID_COLUMN: { key: 'REQUEST_ID_COLUMN', value: 'Request ID' },
  CREATED_ON_COLUMN: { key: 'CREATED_ON_COLUMN', value: 'Created On' },
  REQUEST_STATUS_COLUMN: { key: 'REQUEST_STATUS_COLUMN', value: 'Request Status' },
  STATUS_COLUMN: { key: 'STATUS_COLUMN', value: 'Status' },
  UPDATED_ON_COLUMN: { key: 'UPDATED_ON_COLUMN', value: 'Updated On' },
  TEMPLATE_NAME_COLUMN: { key: 'TEMPLATE_NAME_COLUMN', value: 'Template' },
  REQUEST_TYPE_COLUMN: { key: 'REQUEST_TYPE_COLUMN', value: 'Request type' },
  ACTION_COLUMN: { key: 'ACTION_COLUMN', value: 'Action' },
  
  SUCCESS_STATUS: { key: 'SUCCESS_STATUS', value: 'Success' },
  FAILURE_STATUS: { key: 'FAILURE_STATUS', value: 'Failure' },

  RECEIVED_STATUS_FILTER: { key: 'RECEIVED_STATUS_FILTER', value: 'Received' },
  INQUEUE_STATUS_FILTER: { key: 'INQUEUE_STATUS_FILTER', value: 'Inqueue' },
  PROCESSING_STATUS_FILTER: { key: 'PROCESSING_STATUS_FILTER', value: 'Processing' },
  FAILURE_STATUS_FILTER: { key: 'FAILURE_STATUS_FILTER', value: 'Failure' },
  RETRYING_STATUS_FILTER: { key: 'RETRYING_STATUS_FILTER', value: 'Retrying' },
  FILE_ATTACHED_STATUS_FILTER: { key: 'FILE_ATTACHED_STATUS_FILTER', value: 'File Attached' },
  SENT_STATUS_FILTER: { key: 'SENT_STATUS_FILTER', value: 'Sent' },
  SHARED_WEB_HOOK_STATUS_FILTER: {
    key: 'SHARED_WEB_HOOK_STATUS_FILTER',
    value: 'Shared Web Hook Response',
  },
  FAILURE_SHARED_WEB_HOOK_STATUS_FILTER: {
    key: 'FAILURE_SHARED_WEB_HOOK_STATUS_FILTER',
    value: 'Failure In Share Web Hook Response',
  },

  SANDBOX_FILTER: { key: 'SANDBOX_FILTER', value: 'Sandbox' },
  LIVE_FILTER: { key: 'LIVE_FILTER', value: 'Live' },

  EMPTY_TABLE_DESCRIPTION: { key: 'EMPTY_TABLE_DESCRIPTION', value: 'No Data' },

  SEARCH_REQUEST_ID_PLACEHOLDER: {
    key: 'SEARCH_REQUEST_ID_PLACEHOLDER',
    value: 'Search request id',
  },
  
  SEARCH_BUTTON: { key: 'SEARCH_BUTTON', value: 'Search' },
  CLEAR_BUTTON: { key: 'CLEAR_BUTTON', value: 'Clear' },

  FILTER_CONFIRM_BUTTON: { key: 'FILTER_CONFIRM_BUTTON', value: 'Ok' },
  FILTER_RESET_BUTTON: { key: 'FILTER_RESET_BUTTON', value: 'Reset' },

  RANGE_PICKER_START_PLACEHOLDER: {
    key: 'RANGE_PICKER_START_PLACEHOLDER',
    value: 'Start Date & Time',
  },
  RANGE_PICKER_END_PLACEHOLDER: { key: 'RANGE_PICKER_END_PLACEHOLDER', value: 'End Date & Time' },
  VIEW_DETAILS_TOOLTIP: { key: 'VIEW_DETAILS_TOOLTIP', value: 'View details' },
};
